import React, { useMemo } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { PieChart } from '@mui/x-charts/PieChart';
import CustomLegend from '../CustomLegend.jsx';

const BuySellStageDonut = ({ rows, onLegendClick }) => {
  const theme = useTheme();

  const chartData = useMemo(() => {
    const counts = rows.reduce(
      (acc, row) => {
        const stage = row?.buySellStage || 'Unknown';
        acc[stage] = (acc[stage] || 0) + 1;
        return acc;
      },
      { DAF: 0, D2C2: 0, Complete: 0 }
    );

    return [
      {
        id: 0,
        label: 'DAF',
        value: counts.DAF,
        color: alpha(theme.palette.warning.main, 0.75),
      },
      {
        id: 1,
        label: 'D2C2',
        value: counts.D2C2,
        color: alpha(theme.palette.info.main, 0.75),
      },
      {
        id: 2,
        label: 'Complete',
        value: counts.Complete,
        color: alpha(theme.palette.success.main, 0.75),
      },
    ];
  }, [rows, theme.palette.info.main, theme.palette.success.main, theme.palette.warning.main]);

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <Paper variant="outlined" sx={{ p: 2.5 }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="overline" sx={{ color: 'text.secondary' }}>
            Buy/Sell stage breakout
          </Typography>
        </Box>

        <Box sx={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
          <PieChart
            series={[{ data: chartData, innerRadius: 44, outerRadius: 68 }]} 
            width={220}
            height={200}
            legend={{ hidden: true }}
            margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              {total}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              active stages
            </Typography>
          </Box>
        </Box>

        <CustomLegend data={chartData} onLegendClick={onLegendClick} />
      </Stack>
    </Paper>
  );
};

export default BuySellStageDonut;
